import React from 'react'
import ProjectInfo from '../ProjectInfo'
import violin from "../../../../Assets/images/projects/violindetailed.png"

export default function Violin() {
    return (
        <ProjectInfo
            pic={violin}
            title="Donna Wolf Violin Website"
            maincolor="#710083"
            accentcolor="#cc15b4"
            link="https://www.donnawolfviolin.com/"
            githublink="https://www.donnawolfviolin.com/"
        >
            <p>Created for Donna Wolf the violinist, this website markets her talents and is used as a point of reference for her clients. </p>
            <br />
            <p>This website was developed using wordpress and elementor.</p>
            <br />

        </ProjectInfo>
    )
}
